import _CheckCircle from "@mui/icons-material/CheckCircle";
import React from 'react';
import styled from 'styled-components';
import { COLORS, SIZES, Typography } from '@fupa/fupa-uikit';
import { Button } from '@mui/material';
import UpdateResultHeader from 'app/components/match/liveResult/UpdateResultHeader';
import { useSoftTickerContext } from 'app/hooks/useSoftTickerContext';
import useShowAddScorerButton from 'app/components/match/liveResult/updateScorer/useShowAddScorerButton';
const Container = styled.div.withConfig({
  componentId: "sc-75yad9-0"
})(["display:grid;grid-template-columns:repeat(2,1fr);gap:", ";"], SIZES['16']);
const TextContainer = styled.div.withConfig({
  componentId: "sc-75yad9-1"
})(["min-height:", ";height:", ";grid-column:span 2;justify-self:center;"], props => {
  var _props$height;
  return (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : SIZES['42'];
}, props => {
  var _props$height2;
  return (_props$height2 = props.height) !== null && _props$height2 !== void 0 ? _props$height2 : 'auto';
});
const Placeholder = styled.div.withConfig({
  componentId: "sc-75yad9-2"
})(["height:", ";grid-column:span 2;@media (max-width:330px){display:none;}"], SIZES['8']);
export const Actions = styled.div.withConfig({
  componentId: "sc-75yad9-3"
})(["grid-column:span 2;display:flex;justify-content:space-between;white-space:nowrap;"]);
export default function UpdateSuccess(_ref) {
  let {
    match,
    tickerEvents,
    onClose,
    onResume
  } = _ref;
  const {
    softTickerData
  } = useSoftTickerContext();
  const showAddScorerButton = useShowAddScorerButton(match, tickerEvents);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UpdateResultHeader, {
    match: match,
    resultData: softTickerData.resultData,
    "data-sentry-element": "UpdateResultHeader",
    "data-sentry-source-file": "UpdateSuccess.tsx"
  }), /*#__PURE__*/React.createElement(Container, {
    "data-sentry-element": "Container",
    "data-sentry-source-file": "UpdateSuccess.tsx"
  }, /*#__PURE__*/React.createElement(TextContainer, {
    height: SIZES['24'],
    "data-sentry-element": "TextContainer",
    "data-sentry-source-file": "UpdateSuccess.tsx"
  }, /*#__PURE__*/React.createElement(_CheckCircle, {
    sx: {
      fontSize: 24,
      color: COLORS.darkGreen
    },
    "data-sentry-element": "CheckCircle",
    "data-sentry-source-file": "UpdateSuccess.tsx"
  })), /*#__PURE__*/React.createElement(TextContainer, {
    "data-sentry-element": "TextContainer",
    "data-sentry-source-file": "UpdateSuccess.tsx"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subheading",
    component: "span",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "UpdateSuccess.tsx"
  }, "Spielstand erfolgreich aktualisiert!")), showAddScorerButton ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextContainer, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "Erg\xE4nze im n\xE4chsten Schritt das Torgeschehen, indem du den Torsch\xFCtzen hinzuf\xFCgst.")), /*#__PURE__*/React.createElement(Placeholder, null), /*#__PURE__*/React.createElement(Actions, null, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    sx: {
      color: COLORS.darkestGrey
    },
    onClick: onClose
  }, "Schlie\xDFen"), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "secondary",
    onClick: onResume
  }, "Torsch\xFCtze eintragen"))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextContainer, null), /*#__PURE__*/React.createElement(Placeholder, null), /*#__PURE__*/React.createElement(Actions, null, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "secondary",
    onClick: onClose
  }, "Schlie\xDFen")))));
}